export const SETTING_ROUTE_NAMES = {
  FEES: 'fees',
  TAXES: 'taxes',
  MISC: 'misc',
  MAILCHIMP: 'mailchimp',
  PAYMENTS: 'payments',
  SETUP: 'setup',
  CHECKOUT: 'checkout',
}
